// src/pages/components/MotoVersList.tsx
import * as React from 'react';
import { DataGrid, GridRowsProp, GridColDef,GridRowId,GridToolbar,GridRowSelectionModel, GridRenderCellParams } from '@mui/x-data-grid';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import {IMotoBrand,IMotoBrandResponse,IMotopageProps,IMotoAvRow,IMotoAvResponse,IMotoAvRowGrp,IMotoAvListProps} from '../PageInterfaces'
import Stack from '@mui/material/Stack';
import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import './MotoVersList.css'
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AlarmIcon from '@mui/icons-material/Alarm';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

type Order = 'asc' | 'desc';

function MotoVersList( props:IMotoAvListProps ){
    const [order, setOrder] = React.useState<Order>('asc');
    const [orderBy, setOrderBy] = React.useState<keyof IMotoAvRow>('COMNAME');
    const [selected, setSelected] = React.useState<readonly number[]>([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);
    // const [motoselected, setMotoselected] = React.useState<GridRowSelectionModel>([]);
    const [motoselected, setMotoselected] = React.useState<GridRowSelectionModel>({ type: 'include', ids: new Set() });
    // console.log(props.motolist)
  
    let lrows:any[]=[]
    if(props.motolist) {
      // lrows = []    
      props.motolist.forEach(element => {    
        let el = {
          grpKey: element.grpKey,
          vhstatus: element.vhstatus,
          grpsum: element.grpsum,
          COMPANY: element.grpObj.COMPANY,
          SODTYPE: element.grpObj.SODTYPE,
          MTRMARK: element.grpObj.MTRMARK,
          MTRMODEL: element.grpObj.MTRMODEL,
          MARKCODE: element.grpObj.MARKCODE,
          MDLCODE: element.grpObj.MDLCODE,
          MTRGROUP: element.grpObj.MTRGROUP,
          cccVMODEL: element.grpObj.cccVMODEL,
          MTRL: element.grpObj.MTRL,
          CODE: element.grpObj.CODE,
          CODE1: element.grpObj.CODE1,
          CODE2: element.grpObj.CODE2,
          NAME: element.grpObj.NAME,
          NAME1: element.grpObj.NAME1,
          ISACTIVE: element.grpObj.ISACTIVE,
          MTRONORDER: element.grpObj.MTRONORDER,
          MTRTHIRD: element.grpObj.MTRTHIRD,
          BUSUNITS: element.grpObj.BUSUNITS,
          MTRCATEGORY: element.grpObj.MTRCATEGORY,
          CCCNVEHSTATUS: element.grpObj.CCCNVEHSTATUS,
          QTY1: element.grpObj.QTY1,
          QIMP: element.grpObj.QIMP,
          MTRSEASON: element.grpObj.MTRSEASON,
          CCCLENGTH: element.grpObj.CCCLENGTH,
          QPARAK: element.grpObj.QPARAK,
          QDESM: element.grpObj.QDESM,
          MARKNAME: element.grpObj.MARKNAME,
          MDLNAME: element.grpObj.MDLNAME,
          MNFMODEL: element.grpObj.MNFMODEL,
          MNFVERSION: element.grpObj.MNFVERSION,
          COMNAME: element.grpObj.COMNAME,
          COLRCOD: element.grpObj.COLRCOD,
          COLRNAME: element.grpObj.COLRNAME,
          MGCODE: element.grpObj.MGCODE,
          MGNAME: element.grpObj.MGNAME,
          VHPRICELI: element.grpObj.VHPRICELI,
          PRILICODE: element.grpObj.PRILICODE,
          GENDISCPERC: element.grpObj.GENDISCPERC,
          GENDISCAMNT: element.grpObj.GENDISCAMNT,
          GENCOMMPERC: element.grpObj.GENCOMMPERC,
          GENCOMMAMNT: element.grpObj.GENCOMMAMNT,
          PRICER: element.grpObj.PRICER,
          PRICEW: element.grpObj.PRICEW,
          DISCRPERC: element.grpObj.DISCRPERC,
          DISCRAMNT: element.grpObj.DISCRAMNT,
          BASICPRICE: element.grpObj.BASICPRICE,
          MTRLOT: element.grpObj.MTRLOT,
          ETTPRICE: element.grpObj.ETTPRICE,
          DATEKT: element.grpObj.DATEKT,
          DATCUSTMS: element.grpObj.DATCUSTMS,
          DATAFX: element.grpObj.DATAFX
        }                        
        lrows.push(el)
      });
    }
    // const rows = (props.motolist) ? props.motolist : undefined
    const rows = lrows
  
    const motoAvColumns : GridColDef[] = [  // , width: 150
    { field: 'COMNAME',
      type: 'string',
      headerName: 'Εκδοση',
      disableReorder: false,
      hideable: false,
      flex:4
    },
    {
      field: 'COLRNAME',
      type: 'string',
      headerName: 'Χρώμα',
      disableReorder: true,
      hideable: false,
      flex:2
    },
    { field: 'vhstatus',
    type: 'string',
    headerName: 'Status',
    disableReorder: false,
    hideable: false,
    flex:1
    },
    {
      field: 'PRICEW',
      type: 'number',
      headerName: 'Τιμή Χ',
      disableReorder: true,
      hideable: false,
      flex:2,
      renderCell: (params: GridRenderCellParams<any, number>) => (
        <strong>
            {params.value}
         </strong>
        ),
    },
    {
      field: 'MTRL',
      type: 'string',
      headerName: ' ! ',
      disableReorder: true,
      hideable: false,
      flex:1,
      renderCell: (params: GridRenderCellParams<any, number>) => (
        <strong>
            {/* <Button
              variant="contained"
              size="small"
              style={{ marginLeft: 16 }}
              tabIndex={params.hasFocus ? 0 : -1}
              onClick={ (e) => {handleRowBtnOrderClick(e, params.row)}}
            >
              <ShoppingCartOutlinedIcon />
      </Button> */}
            <IconButton color="primary" aria-label="make an order" tabIndex={params.hasFocus ? 0 : -1}
              onClick={ (e) => {handleRowBtnOrderClick(e, params.row)}} >
              <AddShoppingCartIcon />
            </IconButton>
          </strong>
        ),
    },
    {
      field: 'ETTPRICE',
      type: 'number',
      headerName: 'Ε.Τ.Τ.',
      disableReorder: true,
      hideable: false,
      flex:1
    }
  ]
  
  const handleRowBtnOrderClick = ( e: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowboj:any) => {
    // console.log('btn order selected',rowboj)
    if( (rowboj) && (rowboj.grpKey) && (rowboj.grpKey!=="") && (rowboj.cccVMODEL) && (rowboj.cccVMODEL!=="") && (rowboj.MTRL) && (rowboj.MTRL!=="")
     && (rowboj.COLRCOD) && (rowboj.COLRCOD!=="") ){
        let moto:IMotoAvRow = {
            COMPANY: rowboj['COMPANY'],
            SODTYPE: rowboj['SODTYPE'],
            MTRMARK: rowboj['MTRMARK'],
            MTRMODEL: rowboj['MTRMODEL'],
            MARKCODE: rowboj['MARKCODE'],
            MDLCODE: rowboj['MDLCODE'],
            MTRGROUP: rowboj['MTRGROUP'],
            cccVMODEL: rowboj['cccVMODEL'],
            MTRL: rowboj['MTRL'],
            CODE: rowboj['CODE'],
            CODE1: rowboj['CODE1'],
            CODE2: rowboj['CODE2'],
            NAME: rowboj['NAME'],
            NAME1: rowboj['NAME1'],
            ISACTIVE: rowboj['ISACTIVE'],
            MTRONORDER: rowboj['MTRONORDER'],
            MTRTHIRD: rowboj['MTRTHIRD'],
            BUSUNITS: rowboj['BUSUNITS'],
            MTRCATEGORY: rowboj['MTRCATEGORY'],
            CCCNVEHSTATUS: rowboj['CCCNVEHSTATUS'],
            QTY1: rowboj['QTY1'],
            QIMP: rowboj['QIMP'],
            MTRSEASON: rowboj['MTRSEASON'],
            CCCLENGTH: rowboj['CCCLENGTH'],
            QPARAK: rowboj['QPARAK'],
            QDESM: rowboj['QDESM'],
            MARKNAME: rowboj['MARKNAME'],
            MDLNAME: rowboj['MDLNAME'],
            MNFMODEL: rowboj['MNFMODEL'],
            MNFVERSION: rowboj['MNFVERSION'],
            COMNAME: rowboj['COMNAME'],
            COLRCOD: rowboj['COLRCOD'],
            COLRNAME: rowboj['COLRNAME'],
            MGCODE: rowboj['MGCODE'],
            MGNAME: rowboj['MGNAME'],
            VHPRICELI: rowboj['VHPRICELI'],
            PRILICODE: rowboj['PRILICODE'],
            GENDISCPERC: rowboj['GENDISCPERC'],
            GENDISCAMNT: rowboj['GENDISCAMNT'],
            GENCOMMPERC: rowboj['GENCOMMPERC'],
            GENCOMMAMNT: rowboj['GENCOMMAMNT'],
            PRICER: rowboj['PRICER'],
            PRICEW: rowboj['PRICEW'],
            DISCRPERC: rowboj['DISCRPERC'],
            DISCRAMNT: rowboj['DISCRAMNT'],
            BASICPRICE: rowboj['BASICPRICE'],
            MTRLOT: rowboj['MTRLOT'],
            ETTPRICE: rowboj['ETTPRICE'],
            DATEKT: rowboj['DATEKT'],
            DATCUSTMS: rowboj['DATCUSTMS'],
            DATAFX: rowboj['DATAFX']
        }
        // console.log('to order ',moto)
        props.selMotoCb(moto)
    }
  }

  function getRowId(row:IMotoAvRowGrp) {
    return row.grpKey;
  }
  
    const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const handleChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
      setDense(event.target.checked);
    };
  
    const handleBackBtn = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
       props.retcb(props.retstate)
    }


    
    return (
      <Box component="section" sx={{m: 1}}> {/*  sx={{ width: '100%' }} */}
      
      {/* start of muix data-grid  */}
      <Paper sx={{ width: '100%', mb: 2 }}>

        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar  alt="Remy Sharp" id="motobrandtoplogo"
            src={`${process.env.REACT_APP_MAIN_ROOT}images/${props?.brand?.cardlogo}`}
            sx={{ width: 170, height: 70 }} 
          />
          <div><Button variant="outlined" startIcon={<ArrowBackRoundedIcon />} 
            sx={{ alignSelf: 'start' }}
            onClick={(e) => handleBackBtn(e)}>{'Επιστροφη '}
          </Button>
          </div>
        </Stack>

        <DataGrid rows={rows} columns={motoAvColumns} getRowId={getRowId}
        initialState={{
            pagination: { paginationModel: { pageSize: 25 } },
          }}
        pageSizeOptions={[25, 50]}
        disableColumnMenu        
        checkboxSelection={false}   
        disableMultipleRowSelection={true}
        onRowSelectionModelChange = {(rowSelectionModel, details) => {
          // todo fix it with new selection model
            // console.log("rowSelectionModel",rowSelectionModel)
            // console.log("details",details)
            setMotoselected(rowSelectionModel)
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          columnsManagement: {
            toggleAllMode: 'filteredOnly',          
          },
          toolbar: {printOptions: { disableToolbarButton: true },csvOptions: { disableToolbarButton: true },}
        }} 
        />        
      </Paper>
      {/* end of muix data-grid  */}
  
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </Box>
    )
}
export default MotoVersList

{/* start of mui table   discontinued 
      <Paper sx={{ width: '100%', mb: 2 }}>
        <MotoAvEnhTableToolbar numSelected={selected.length} />
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <MotoAvEnhTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              //onSelectAllClick={handleSelectAllClick}
              //onRequestSort={handleRequestSort}
              rowCount={(props.motolist) ? props.motolist?.length : 0}
            />
            <TableBody>
              { //visibleRows.map((row, index) => {
              props.motolist?.map((row, index) => {
                const isItemSelected = isSelected(parseInt(row.MTRL));
                const labelId = `enhanced-table-checkbox-${index}`;
                
                return (
                  <TableRow
                    hover
                    // onClick={(event) => handleClick(event, row.id)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={parseInt(row.MTRL)}
                    selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        checked={isItemSelected}
                        inputProps={{
                          'aria-labelledby': labelId,
                        }}
                      />
                    </TableCell>
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      padding="none"
                    >
                      {row.COMNAME}
                    </TableCell>
                    <TableCell align="left">{row.COLRNAME}</TableCell>
                    <TableCell align="right">{row.PRICEW}</TableCell>
                    <TableCell align="right">{row.ETTPRICE}</TableCell>
  
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={(props.motolist) ? props.motolist?.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
        
       end of mui table  
*/}

/*  type Order = 'asc' | 'desc';

interface MotoAvHeadCell {
  disablePadding: boolean;
  id: keyof IMotoAvRow;
  label: string;
  numeric: boolean;
}
const motoAvheadCells: readonly MotoAvHeadCell[] = [
  {
    id: 'COMNAME',
    numeric: false,
    disablePadding: true,
    label: 'Εκδοση',
  },
  {
    id: 'COLRNAME',
    numeric: false,
    disablePadding: true,
    label: 'Χρώμα',
  },
  {
    id: 'PRICEW',
    numeric: true,
    disablePadding: true,
    label: 'ΧΤ',
  },
  {
    id: 'ETTPRICE',
    numeric: true,
    disablePadding: true,
    label: 'ΕΤΤ',
  },
]

interface MotoAvEnhTableProps {
  numSelected: number;
  // onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
  // onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}
function MotoAvEnhTableHead(props: MotoAvEnhTableProps) {
  // const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const { order, orderBy, numSelected, rowCount } = props;
  const createSortHandler =
    (property: keyof IMotoAvRow) => (event: React.MouseEvent<unknown>) => {
      // onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            // onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell>
        {motoAvheadCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

interface MotoAvEnhTableToolbarProps {
  numSelected: number;
}

function MotoAvEnhTableToolbar(props: MotoAvEnhTableToolbarProps) {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Εκδόσεις
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}
 const handleRequestSort = (
      event: React.MouseEvent<unknown>,
      property: keyof Data,
    ) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        const newSelected = rows.map((n) => n.id);
        setSelected(newSelected);
        return;
      }
      setSelected([]);
    };
  
    const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
      const selectedIndex = selected.indexOf(id);
      let newSelected: readonly number[] = [];
  
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1),
        );
      }
      setSelected(newSelected);
    };


    const isSelected = (id: number) => selected.indexOf(id) !== -1;
    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - ((props.motolist) ? props.motolist?.length : 0)) : 0;
  
    // const visibleRows = React.useMemo(
    //   () =>
    //     stableSort(rows, getComparator(order, orderBy)).slice(
    //       page * rowsPerPage,
    //       page * rowsPerPage + rowsPerPage,
    //     ),
    //   [order, orderBy, page, rowsPerPage],
    // );


    */